import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Bs4MainDispatch from '../../Bs4MainDispatch';

import Bs4GenericField from './Bs4GenericField'

export default class Bs4Mapa extends Bs4GenericField {

  hesValue () {return false;}
  
  ViewComponentField = (props) => {
    const formField = this;
    this.refFocus = React.useRef();
    const link = Bs4MainDispatch.getUrlPath(this.props.field.srclink)    
    let height = parseInt(this.props.field.height);    
    height = height ? height + 'px' : '150px'

    return (
      <FormControl fullWidth >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <iframe ref={this.refFocus} src={link} width={"100%"} height={height} style={{border: 'none'}}/> 
      </FormControl>
    );
  }
}